import { apiClient } from "lib/apiClient";
import {
  IStandardGeographyDto,
  StandardGeographyTypeEnum,
} from "features/MarketAreas/types";

export type TStandardGeographyParams = {
  type: StandardGeographyTypeEnum;
  id?: string;
  parentLayer?: string;
  parentId?: string;
};

export const getStandardGeographies = async (
  params: TStandardGeographyParams,
  signal?: AbortSignal
): Promise<IStandardGeographyDto[]> => {
  const response = await apiClient.get<IStandardGeographyDto[]>(
    "/market-areas/helper/coordinates",
    { params, signal }
  );
  return response.data;
};
